(() => {
  let oneTime = false;
  let pending = '';
  let lastAttempt = 0;
  let timer;
  const update = () => {
    const root = document.querySelector('.product__main__content');
    if (!root) return;
    root.classList.add('nc-purchase', 'nc-auto-copy');
    const heading = root.querySelector('h1');
    const titles = {'patient-pouch': 'NavaClick Patient Pouches', 'essentials-box': 'NavaClick Essentials Kit', 'needles-24x9': 'Low Dead Space Needles, Sterile'};
    const shortTitle = titles[location.pathname.split('/').pop()];
    if (heading && shortTitle && heading.textContent !== shortTitle) heading.textContent = shortTitle;
    const guarantee = document.getElementById('nc-guarantee-template');
    const submit = root.querySelector('.product__submit');
    if (guarantee && submit && !root.querySelector('.nc-guarantee')) submit.after(guarantee.content.cloneNode(true));
    const sourceButton = root.querySelector('[data-add-to-cart]');
    const mirror = document.querySelector('.conversion-mobile-cart button');
    if (sourceButton && mirror) {
      const label = sourceButton.textContent.replace(/\s+/g, ' ').trim();
      if (mirror.textContent !== label) mirror.textContent = label;
      mirror.disabled = sourceButton.disabled;
    }
    const title = root.querySelector('.product__block__title');
    const buttonPrice = root.querySelector('[data-button-price]');
    if (title && buttonPrice) {
      let price = root.querySelector('.nc-price');
      if (!price) {
        price = document.createElement('div');
        price.className = 'nc-price';
        price.setAttribute('aria-live', 'polite');
        price.innerHTML = '<strong></strong><small></small>';
        title.after(price);
      }
      const amount = buttonPrice.textContent.trim();
      if (price.firstElementChild.textContent !== amount) price.firstElementChild.textContent = amount;
      const config = root.querySelector('input[name="options[Configurations]"]:checked');
      const count = config?.value.match(/\d+/)?.[0];
      const data = root.querySelector('[data-nc-purchase-copy]');
      let unit = '';
      if (count && data?.dataset.pouches === 'true') {
        unit = count + ' ' + data.dataset.unitLabel + ' · ' + new Intl.NumberFormat('en-US', {style: 'currency', currency: data.dataset.currency}).format(Number(amount.replace(/[^0-9.]/g, '')) / Number(count)) + ' ' + data.dataset.perUnit;
      }
      if (price.lastElementChild.textContent !== unit) price.lastElementChild.textContent = unit;
    }
    const field = root.querySelector('[data-subscription-selectors]');
    if (!field) return;
    const selected = field.querySelector('[data-plan-input]:checked');
    if (selected) { pending = ''; return; }
    if (oneTime) return;
    const group = field.querySelector('[data-subscription-group] input[data-toggles-group]');
    const key = field.dataset.variant + ':' + group?.value;
    if (group && (pending !== key || Date.now() - lastAttempt > 1500)) {
      pending = key;
      lastAttempt = Date.now();
      group.checked = true;
      group.dispatchEvent(new Event('change', {bubbles: true}));
    }
  };
  document.addEventListener('change', event => {
    if (event.isTrusted && event.target.matches('[data-toggles-group], [data-plan-input]')) {
      oneTime = event.target.hasAttribute('data-one-time');
      pending = '';
    }
  }, true);
  const start = () => {
    new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(update, 80); }).observe(document.querySelector('main') || document.body, {childList: true, subtree: true, characterData: true});
    update();
    let attempts = 0;
    const retry = setInterval(() => { update(); if (++attempts >= 8) clearInterval(retry); }, 500);
  };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, {once: true});
})();
